export const portAuthoritySort = (table) => {
  const collator = new Intl.Collator("el", {
    sensitivity: "base",
  });
  const LocaleSort = table?.sort((a, b) => {
    const first = a.dscr.trim().split(" ")[1];
    const second = b.dscr.trim().split(" ")[1];

    return collator.compare(first, second);
  });
  return LocaleSort;
};
